module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h3>STREAK TRACKER</h3>\n\n';
 if(season_completed){ 
__p+='\n	<h4>STREAK COMPETITION IS NOW OVER FOR SEASON 2023!</h4>\n';
 } else if(is_know_status){ 
__p+='\n	';
 if(is_active){ 
__p+='\n		<h4>YOU ARE STILL IN THE RUNNING TO WIN!</h4>\n	';
 } else { 
__p+='\n		<p><span class="mark">You\'ve been eliminated from Streak!</span> Continue making your regular season tips to stay in the running for other awesome prizes!</p>\n	';
 } 
__p+='\n';
 } 
__p+='\n\n<h5>How to play</h5>\n<p>Remain in the Streak comp by correctly selecting one winning team in each round. However! You cannot tip the same team again for any subsequent Streak rounds.</p>\n<a href="/rankings/streak">See streak rankings here</a>\n';
}
return __p;
};
